import { useModal } from "@/common/contexts/Modal.context";
import UploadDocumentModal from "@/components/Modals/DocumentModal/UploadDocument.modal";
import { UploadIcon } from "@/components/icon";

export default function UploadDocument() {
  const { openModal } = useModal();
  const onClick = () => {
    openModal(<UploadDocumentModal />);
  };
  return (
    <button
      onClick={onClick}
      className="text-base font-kanit  capitalize h-10  text-primary px-3 rounded-lg flex justify-between gap-2 items-center text-nowrap bg-primary text-white transition"
    >
      <UploadIcon />
      Upload Document
    </button>
  );
}
